import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormFieldConfig } from 'src/app/shared/components/dynamic-component-shared/dropdown/form_field_config';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { Image } from 'src/app/shared/entities/image';
import { TemplateService } from 'src/app/services/template.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { readImageInfo } from 'src/app/shared/helpers/image';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.css'],
    providers: [MessageService],
})
export class ImageComponent implements OnInit {
    @Input() config: FormFieldConfig;
    @Input() data: any;
    value: any = {};
    selectedFile: File | null;
    imagesMap: Image[] = [];
    uploadPath: string;
    uploadUrl: string;
    image: any = {};
    typeName: any;
    isEditMode: boolean = false;
    @Input()
    locales: string[];
    constructor(
        private httpclientService: HttpclientService,
        private templateService: TemplateService,
        public userService: UserService,
        private translate: TranslateService,
        private messageService: MessageService,
        private http: HttpClient
    ) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            this.config.id = '4';
            this.config = changes['config'].currentValue;
            this.typeName = this.config.typeName;

            if (this.config.images) {
                this.imagesMap = this.config.images;
            }
            if (this.config.value) {
                this.image = this.config?.value;
            }
            if (this.config.editMode) {
                this.isEditMode = this.config.editMode;
            }
            this.isEditMode = this.config.editMode;

            this.uploadPath = this.config.uploadPath;
            this.uploadUrl = this.config.uploadUrl;
        }
    }
    uploadImageLayout(event: any) {
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }

        this.uploadPath = this.uploadPath;
        this.uploadUrl = this.config.uploadUrl;

        this.uploadMultipleImageLayout(event.target.files, 0);
    }

    removeImageLayout(valueImage: any) {
        let id = valueImage.id;
        let url = `image/delete/${id}`;

        if (this.config.singleImageMode) {
            this.deleteSingleImageLayout(valueImage);
        } else {
            this.deleteImageLayout(valueImage);
        }
    }

    // uploadSingleImageLayout(formData: FormData, headers: any) {
    //   this.httpclientService
    //     .postWithHeader(formData, headers, this.uploadUrl)
    //     .subscribe((res: any) => {
    //       this.image = res;
    //       this.config.value = res;
    //     });
    // }

    async uploadMultipleImageLayout(files: any[], index: number) {
        if (index >= 0 && index < files.length) {
            if (this.config.type === 'RESOURCE_FILES' || this.config.type === 'file') {
                // const imageInfo = await readImageInfo(files[index]);
                // if (imageInfo?.dpi && imageInfo?.dpi !== 0 && imageInfo?.dpi < 300) {
                //   this.messageService.add({severity:'error', summary: 'Erreur', detail: this.translate.instant('Admin.Error.image-upload-min', {fileName: files[index].name, attr: 'DPI', value: '300'})});
                //   return;
                // }
                // if (imageInfo?.width && imageInfo?.width < 378) {
                //   this.messageService.add({severity:'error', summary: 'Erreur', detail: this.translate.instant('Admin.Error.image-upload-min', {fileName: files[index].name, attr: 'Width', value: '378'})});
                //   return;
                // }
                // if (imageInfo?.height && imageInfo?.height < 378) {
                //   this.messageService.add({severity:'error', summary: 'Erreur', detail: this.translate.instant('Admin.Error.image-upload-min', {fileName: files[index].name, attr: 'Height', value: '378'})});
                //   return;
                // }

                const formData = new FormData();
                formData.append('file', files[index]);

                this.httpclientService.postWithHeader(formData, {}, '/resource-files').subscribe({
                    next: (resourceFile) => {
                        this.imagesMap.push(resourceFile);
                    },
                    error: (error) => {
                        console.error('Error uploading image:', error);
                    },
                });
            } else {
                const formData = new FormData();
                const headers = {};
                formData.append('path', this.uploadPath);
                formData.append('file', files[index]);

                this.httpclientService.postWithHeader(formData, headers, this.uploadUrl).subscribe(
                    (response) => {
                        //
                        // Assuming the response contains the uploaded image URL
                        const nom = response.nom;

                        // Add the image URL to the imagesMap
                        this.imagesMap.push(response);

                        this.uploadMultipleImageLayout(files, index + 1);
                    },
                    (error) => {
                        console.error('Error uploading image:', error);
                    }
                );
            }
        }
    }

    // deleteImageLayout(valueImage: any) {
    //   let id = valueImage.id;
    //   let url = `image/delete/${id}`;

    //   this.templateService.deleteImage(url).subscribe(() => {
    //     this.imagesMap = Object.values(this.imagesMap)
    //       .filter((image) => image.id !== id)
    //       .reduce((obj: { [key: string]: Image }, image) => {
    //         obj[image.id] = image;
    //         return obj;
    //       }, {});
    //     // Perform any additional logic here
    //   });
    // }

    deleteImageLayout(valueImage: any) {
        let id = valueImage.id;
        let url = `image/delete/${id}`;

        this.templateService.deleteImage(url).subscribe(() => {
            this.imagesMap = this.imagesMap.filter((image) => image.id !== id);
            // Perform any additional logic here
        });
    }

    deleteSingleImageLayout(valueImage: any) {
        let id = valueImage.id;
        let url = `image/delete/${id}`;

        this.templateService.deleteImage(url).subscribe(() => {
            this.image = {};
            this.config.value = {};

            // Perform any additional logic here
        });
    }

    downloadHandler(image: any, isThumbnail: boolean = false) {
        let imageName: string = isThumbnail ? image.thumbnailUrl : image.url;
        imageName = imageName.substring(
            imageName.indexOf('/resource-files/') + '/resource-files/'.length
        );
        imageName = imageName.substring(0, imageName.indexOf('?'));

        if (this.hasUuid(imageName)) {
            imageName = imageName.substring(imageName.indexOf('_') + 1);
        }
        if (this.isIronside() && this.config.value) {
            let prefix: string = '';
            if (this.config.value.linkToProduct && this.config.value.linkToProduct.length > 0) {
                prefix += this.config.value.linkToProduct[0].value;
            }
            if (this.config.value.linkToPartner && this.config.value.linkToPartner.length > 0) {
                prefix += this.config.value.linkToPartner[0].value;
            }
            if (this.config.value.linkToSupplier && this.config.value.linkToSupplier.length > 0) {
                prefix += this.config.value.linkToSupplier[0].value;
            }
            if (prefix === '') {
                prefix += this.config.value.title;
            }
            if (this.config.value.typeOfResource) {
                try {
                    prefix += `-${this.config.value.typeOfResource.labels[this.locales[0]]}`;
                } catch (e) {}
            }
            if (isThumbnail) {
                prefix += '-vignette';
            }
            const extension: string = imageName.substring(imageName.lastIndexOf('.'));
            imageName = `${prefix}${extension}`;
        }
        imageName = decodeURIComponent(imageName).toUpperCase().replace(/ /g, '-');
        imageName = imageName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

        this.http
            .get(isThumbnail ? image.thumbnailUrl : image.url, { responseType: 'blob' })
            .subscribe((blob) => {
                const urlBlob = URL.createObjectURL(blob);

                const el = document.createElement('a');
                el.href = urlBlob;
                el.download = imageName; // Le nom que vous souhaitez donner au fichier
                el.click();

                URL.revokeObjectURL(urlBlob); // Nettoyage
            });
    }

    private hasUuid(imageName: string): boolean {
        const uuid: string = imageName.substring(0, imageName.indexOf('_'));
        return (uuid.match(/-/g) || []).length === 4;
    }

    private isIronside(): boolean {
        return environment.client === 'ironside';
    }

    getAcceptTypes(): string {
        if (this.config && (this.config as any).acceptTypes) {
            return (this.config as any).acceptTypes;
        }
        return '*/*';
    }
}
